import React, { Component } from 'react'
import { InlineTextField } from 'legacy/components/Forms'
import Dropdown from 'legacy/components/Dropdown'

type CellType = 'dropdown' | 'currency'

interface Props {
  type: CellType
  attribute: string
  // eslint-disable-next-line
  options?: any[]
  item: {
    [index: string]: string
  }
  onChange: (attribute: string, value: string) => void
}

interface State {
  value: string
  isBusy: boolean
  isError: boolean
}

class ProductLocationsCell extends Component<Props, State> {
  readonly state: State = {
    value: this.props.item[this.props.attribute],
    isBusy: false,
    isError: false,
  }

  onChange = (value: string) => {
    this.setState(
      {
        isError: false,
        value,
      },
      () => this.props.onChange(this.props.attribute, value)
    )
  }

  render() {
    const { attribute, type, options } = this.props

    switch (type) {
      case 'dropdown':
        return (
          <Dropdown
            width="130px"
            theme="light"
            value={this.state.value}
            isBusy={this.state.isBusy}
            isError={this.state.isError}
            onChange={this.onChange}
            options={options}
          />
        )
      case 'currency':
        return (
          <InlineTextField
            name={attribute}
            type="currency"
            isBusy={this.state.isBusy}
            isError={this.state.isError}
            value={this.state.value}
            onChange={this.onChange}
          />
        )
      default:
        return null
    }
  }
}

export default ProductLocationsCell
